import React from "react";

import { ImageLoadingType } from "../../Image/Image";
import { MultiBannerItem } from "../../../../ContentfulTypes";

import { DesktopBannerImage, TabletBannerImage, MobileBannerImage } from "./styles";

interface Props {
  bannerData: MultiBannerItem;
  index: number;
  useSharpImage?: boolean;
  imageLoadingType?: ImageLoadingType;
}
const MultiHeroBannerImage = ({
  bannerData,
  index,
  useSharpImage = false,
  imageLoadingType,
}: Props) => {
  const loading = index === 0 ? ImageLoadingType.Eager : ImageLoadingType.Lazy;
  const desktopImage = bannerData?.foregroundImageDesktop;
  const tabletImage = bannerData?.foregroundImageTablet;
  const mobileImage = bannerData?.foregroundImageMobile;
  if (!useSharpImage) {
    delete desktopImage?.asset?.localImage?.childImageSharp;
    delete tabletImage?.asset?.localImage?.childImageSharp;
    delete mobileImage?.asset?.localImage?.childImageSharp;
  }
  return (
    <>
      <DesktopBannerImage
        image={desktopImage}
        loading={imageLoadingType ?? loading}
      />
      <TabletBannerImage
        image={tabletImage}
        loading={imageLoadingType ?? loading}
      />
      <MobileBannerImage
        image={mobileImage}
        loading={imageLoadingType ?? loading}
      />
    </>
  );
};

export default MultiHeroBannerImage;
